export function HeroBanner({ icon: Icon, title, subtitle, children, testid }) {
  return (
    <div className="relative overflow-hidden rounded-2xl border border-border bg-gradient-to-r from-sky-100 via-sky-50 to-sky-200/70 dark:from-[#0f1b33] dark:via-[#0b1226] dark:to-[#132a4a] p-4 sm:p-5" data-testid={testid}>
      <div className="pointer-events-none absolute -right-16 -top-20 h-64 w-64 rounded-full bg-sky-400/20 dark:bg-sky-500/10 blur-3xl" />
      <div className="pointer-events-none absolute right-24 -bottom-24 h-56 w-56 rounded-full bg-[#F04E23]/15 blur-3xl" />
      <div className="relative flex flex-wrap items-start justify-between gap-3">
        <div className="flex items-start gap-3">
          <div className="h-12 w-12 shrink-0 rounded-full bg-white dark:bg-white/10 shadow flex items-center justify-center"><Icon className="w-6 h-6 text-[#F04E23]" /></div>
          <div>
            <h1 className="text-2xl sm:text-3xl font-heading font-bold leading-tight">{title}</h1>
            {subtitle && <p className="text-xs sm:text-sm text-muted-foreground mt-0.5">{subtitle}</p>}
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-2">{children}</div>
      </div>
    </div>
  );
}

const TONES = {
  blue: "from-sky-500 to-blue-600", green: "from-emerald-500 to-green-600", orange: "from-orange-500 to-rose-500",
  purple: "from-violet-500 to-purple-600", rose: "from-rose-500 to-red-600", slate: "from-slate-500 to-slate-700",
};

export function StatCard({ icon: Icon, label, value, hint, tone = "blue", testid, onClick, active }) {
  return (
    <button type="button" onClick={onClick} className={`text-left rounded-2xl bg-gradient-to-br ${TONES[tone]} text-white p-4 shadow-md transition-transform hover:-translate-y-0.5 ${active ? "ring-2 ring-offset-2 ring-offset-background ring-white/80" : ""} ${onClick ? "cursor-pointer" : "cursor-default"}`} data-testid={testid}>
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 rounded-full bg-white/20 flex items-center justify-center shrink-0"><Icon className="w-5 h-5" /></div>
        <div className="min-w-0">
          <div className="text-[11px] opacity-90">{label}</div>
          <div className="text-2xl font-mono font-bold leading-tight">{value}</div>
          {hint && <div className="text-[10px] opacity-80">{hint}</div>}
        </div>
      </div>
    </button>
  );
}
